import { render, staticRenderFns } from "./myVideo.vue?vue&type=template&id=e4c7a8ae&scoped=true"
import script from "./myVideo.vue?vue&type=script&lang=js"
export * from "./myVideo.vue?vue&type=script&lang=js"
import style0 from "./myVideo.vue?vue&type=style&index=0&id=e4c7a8ae&prod&scoped=true&lang=css"
import style1 from "./myVideo.vue?vue&type=style&index=1&id=e4c7a8ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c7a8ae",
  null
  
)

export default component.exports